import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut, onAuthStateChanged, createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyBVaX6HTDdwW5G6WLFnfxklncmOZdWx470",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "riglandtravels-87cab.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "riglandtravels-87cab",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "riglandtravels-87cab.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "136171343914",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:136171343914:web:fb5635ac3606d2c887b353",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-F6MNHBLZS0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

export { signInWithPopup, signOut, onAuthStateChanged, createUserWithEmailAndPassword, signInWithEmailAndPassword };
